// extracted by mini-css-extract-plugin
module.exports = {"iconPulse":"basketIcon_iconPulse__3Ul0J","pulse-red":"basketIcon_pulse-red__QaRS7"};